module.exports = __webpack_public_path__ + "img/1393315066.88733d35.jpg";